import getTranslation from 'bdata-sns-shared/utils/getTranslation';
import GameStateTypes from 'bdata-sns-shared/game/types/GameStateTypes';

const { PREVIEW, LIVE, FINAL } = GameStateTypes;
const EMPTY = '';

const getGameStateExtendedLabel = (options, dictMap) => {
    const {
        gameState,
        isPostponed,
        isCancelled,
        isPreGameDelay,
        isWarmup,
        isSuspended,
        isInGameDelay,
        isInstantReplay,
        isUmpireReview,
        isManagerChallenge,
        dictionary,
        perfectGame,
        noHitter,
        isMiniSB,
        isSuspendedResumptionOnDate,
        currentInning,
        inningState
    } = options;

    let infoText = EMPTY;
    const isNotableGame = (perfectGame || noHitter);

    switch (gameState) {
    case PREVIEW:
        if (isPreGameDelay) {
            infoText = getTranslation(dictionary, 'game_status_delayed', 'Delay');
            return infoText;
        }
        return infoText;
    case LIVE:
        if (isWarmup) {
            infoText = getTranslation(dictionary, 'game_status_warmup', 'Warmup');
            if (isMiniSB) {
                infoText = getTranslation(dictionary, 'game_status_warmup_short', 'Warmup').toUpperCase();
            }
        } else if (isSuspended && !isSuspendedResumptionOnDate) {
            infoText = (!isNotableGame) ? getTranslation(dictionary, 'game_status_suspended', 'Suspended') : getTranslation(dictionary, 'game_susp_short', 'SUSP');
        } else if (isSuspendedResumptionOnDate) {
            infoText = `${getTranslation(dictionary, inningState, inningState).toUpperCase()} ${currentInning}`;
        } else if (isInGameDelay) {
            infoText = getTranslation(dictionary, 'game_status_delayed', 'Delay');
        } else if (isInstantReplay) {
            infoText = (!isNotableGame) ? getTranslation(dictionary, 'game_status_replay', 'Replay') : EMPTY;
        } else if (isManagerChallenge) {
            infoText = (!isNotableGame) ? getTranslation(dictionary, 'game_status_manager_challenge_short', 'Challenge') : EMPTY;
        } else if (isUmpireReview) {
            infoText = (!isNotableGame) ? getTranslation(dictionary, 'game_status_umpire_review_short', 'Review') : EMPTY;
        }
        return infoText;
    case FINAL:
        if (isCancelled) {
            infoText = getTranslation(dictionary, 'game_status_cancelled', 'Cancelled');
        } else if (isPostponed) {
            infoText = (!isNotableGame) ? getTranslation(dictionary, 'game_status_postponed', 'Postponed') : getTranslation(dictionary, 'game_ppd_short', 'PPD');
        }
        return infoText;
    default:
        return infoText;
    }
};

export default getGameStateExtendedLabel;
